import React, { Component } from 'react';
import {
    Box,
    Typography,
    TextField,
    Grid,
    Paper,
    MenuItem,
    InputAdornment,
    Button
} from '@mui/material';
import StorefrontIcon from '@mui/icons-material/Storefront';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import SaveIcon from '@mui/icons-material/Save';
import { toast } from 'react-toastify';
class StoreSettings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            nome: '', // Mantendo o exemplo do seu print
            descricao: '',
            profileType: '', // 'lojista' ou 'fornecedor'
            segment: '',
            cnpj: '',

        };
    }

    componentDidMount() {
        var { nome, descricao, profileType, segment, cnpj } = this.props.data
        this.setState({ nome, descricao, profileType, segment, cnpj })
    }


    handleProfileSelect = (type) => {
        this.setState({ profileType: type });
    };

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    render() {
        const { profileType } = this.state;
        const inputStyle = {
            '& .MuiOutlinedInput-root': {
                borderRadius: '8px',
                backgroundColor: '#f8f9fa'
            }
        };
        // Estilo comum para os cards de perfil
        const cardStyle = (type) => ({
            p: 2,
            display: 'flex',
            alignItems: 'flex-start',
            cursor: 'pointer',
            borderRadius: '12px',
            border: '2px solid',
            transition: '0.2s',
            height: '100%',
            backgroundColor: profileType === type ? '#f9f6ff' : '#fff',
            borderColor: profileType === type ? '#6200ee' : '#e0e0e0',
            boxShadow: 'none'
        });

        return (
            <Box sx={{ p: 0, margin: '0 auto' }}>
                {/* Cabeçalho */}
                <Typography variant="h6" sx={{ fontWeight: 600 }}>Dados da Loja</Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
                    Nome, CNPJ e endereço
                </Typography>

                {/* Nome da Loja */}
                <Box sx={{ mb: 3 }}>
                    <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 1 }}>
                        Nome da loja *
                    </Typography>
                    <TextField
                        fullWidth
                        name="nome"
                        value={this.state.nome}
                        onChange={this.handleChange}
                        placeholder="Nome da sua loja"
                        variant="outlined"
                        size="small"
                        sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                    />
                    <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block' }}>
                        Este nome aparece no topo do seu catálogo
                    </Typography>
                </Box>

                {/* Descrição */}
                <Box sx={{ mb: 4 }}>
                    <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 1 }}>
                        Descrição
                    </Typography>
                    <TextField
                        fullWidth
                        multiline
                        rows={4}
                        name="descricao"
                        value={this.state.descricao}
                        onChange={this.handleChange}
                        placeholder="Conte um pouco sobre sua loja..."
                        variant="outlined"
                        sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
                    />

                </Box>

                {/* Perfil da Loja */}
                <Box sx={{ mb: 4 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                        <StorefrontIcon sx={{ fontSize: 20, mr: 1, color: '#666' }} />
                        <Typography variant="body1" sx={{ fontWeight: 'bold' }}>Perfil da Loja</Typography>
                    </Box>

                    <Typography variant="body2" sx={{ mb: 2, fontWeight: 500 }}>Você é:</Typography>

                    <Grid container spacing={2}>
                        {/* Opção Lojista */}
                        <Grid item xs={12} sm={6}>
                            <Paper
                                onClick={() => this.handleProfileSelect('lojista')}
                                sx={cardStyle('lojista')}
                            >
                                <StorefrontIcon sx={{ color: profileType === 'lojista' ? '#6200ee' : '#666', mr: 1.5, mt: 0.5 }} />
                                <Box>
                                    <Typography variant="body2" sx={{ fontWeight: 'bold', color: profileType === 'lojista' ? '#6200ee' : 'inherit' }}>
                                        Sou lojista
                                    </Typography>
                                    <Typography variant="caption" color="text.secondary">
                                        Quero organizar e divulgar meu catálogo online para meus clientes.
                                    </Typography>
                                </Box>
                            </Paper>
                        </Grid>

                        {/* Opção Fornecedor */}
                        <Grid item xs={12} sm={6}>
                            <Paper
                                onClick={() => this.handleProfileSelect('fornecedor')}
                                sx={cardStyle('fornecedor')}
                            >
                                <PrecisionManufacturingIcon sx={{ color: profileType === 'fornecedor' ? '#6200ee' : '#666', mr: 1.5, mt: 0.5 }} />
                                <Box>
                                    <Typography variant="body2" sx={{ fontWeight: 'bold', color: profileType === 'fornecedor' ? '#6200ee' : 'inherit' }}>
                                        Sou fornecedor
                                    </Typography>
                                    <Typography variant="caption" color="text.secondary">
                                        Quero disponibilizar meus produtos para lojistas e automatizar atualizações.
                                    </Typography>
                                </Box>
                            </Paper>
                        </Grid>
                    </Grid>
                </Box>

                {/* Segmento */}
                <Box sx={{ mb: 3 }}>
                    <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 1 }}>
                        Segmento
                    </Typography>
                    <TextField
                        select
                        fullWidth
                        name="segment"
                        value={this.state.segment}
                        onChange={this.handleChange}
                        size="small"
                        variant="outlined"
                        sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                    >
                        <MenuItem value="1">Moda</MenuItem>
                        <MenuItem value="2">Alimentos & Bebidas</MenuItem>
                        <MenuItem value="3">Eletrônicos</MenuItem>
                        <MenuItem value="4">Assistência Técnica</MenuItem>
                        <MenuItem value="5">Casa, Decoração & Construção</MenuItem>
                        <MenuItem value="6">Serviços & Instalações</MenuItem>
                        <MenuItem value="7">Sob Encomenda / Personalizados</MenuItem>
                    </TextField>
                    <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block' }}>
                        O segmento ajuda a personalizar sua experiência e recomendações
                    </Typography>
                </Box>

                <Box sx={{ mb: 3 }}>
                    <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 1 }}>
                        CNPJ
                    </Typography>
                    <TextField

                        name="cnpj"
                        value={this.state.cnpj}
                        onChange={this.handleChange}
                        size="small"
                        variant="outlined"
                        sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                    />
                </Box>

                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
                    <Button
                        variant="contained"
                        startIcon={<SaveIcon />}
                        onClick={() => {
                            fetch(`${process.env.REACT_APP_API_URL}/settings/store`, {
                                method: 'POST',
                                credentials: 'include',
                                headers: {
                                    'Content-Type': 'application/json',
                                },
                                body: JSON.stringify({
                                    nome: this.state.nome,
                                    descricao: this.state.descricao,
                                    profileType: this.state.profileType,
                                    cnpj: this.state.cnpj,
                                    segment: this.state.segment,

                                }),
                            })
                                .then((response) => {
                                    if (response.ok) {
                                        toast.success('Configurações salvas com sucesso!');
                                    } else {
                                        toast.error('Erro ao salvar configurações.');
                                    }
                                })
                                .catch((error) => {
                                    console.error('Erro ao salvar configurações:', error);
                                    toast.error('Erro ao salvar configurações.');
                                });
                        }}
                        sx={{
                            backgroundColor: '#6200ee',
                            textTransform: 'none',
                            borderRadius: '8px',
                            px: 3,
                            py: 1,
                            fontWeight: 600,
                            '&:hover': {
                                backgroundColor: '#4a00b5',
                            },
                        }}
                    >
                        Salvar Alterações
                    </Button>
                </Box>


            </Box>
        );
    }
}

export default StoreSettings;